import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  flat: "",
  class: "bg-white d-flex flex-column justify-content-between h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "thread-list",
  style: {"height":"90%"}
}
const _hoisted_3 = { class: "question-box me-5" }
const _hoisted_4 = { class: "question-num" }
const _hoisted_5 = {
  key: 0,
  class: "me-2"
}
const _hoisted_6 = { class: "me-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 2,
  class: "mt-2",
  style: {"color":"#666666"}
}

import { ref, watch, onMounted, onUnmounted } from 'vue'
import { UserQuestionListForm } from '../../../api/v2/forms/user_question'
import UserQuestion from '../../../api/v2/models/user_question'
import Pagination from '../../models/pagination'
import Question from '../../models/question'
import { userQuestionState } from '../../stores/user_quetions'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { makeChannel, removeChannel } from '../../../../action_cable/cable'
import { eventBus, EVENTS } from '../../utils/eventBus'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserQuestionList',
  props: {
    relativeableType: { default: '' },
    relativeableId: { default: 0 },
    onClickQuestion: {}
  },
  setup(__props: any) {

const props = __props

const questions = ref<UserQuestion[]>([])
const pagination = ref<Pagination>(new Pagination({}))
const chanel = ref<any>(null)
const isLoading = ref(true)
const userQuestionListForm = ref(new UserQuestionListForm())

const selectPage = async (page: number) => {
  userQuestionListForm.value.page = page
  await getList()
}

const onQuestionClick = (question: UserQuestion) => {
  if (props.onClickQuestion) {
    props.onClickQuestion(question)
  } else {
    window.open(`/classroom/questions/${question.id}`, '_blank')
  }
}

const getList = async () => {
  if (props.relativeableType) {
    userQuestionListForm.value.relativeableType = props.relativeableType
    userQuestionListForm.value.relativeableId = props.relativeableId
  }

  try {
    const [pag, ques] = await userQuestionState.fetchList(userQuestionListForm.value)
    pagination.value = pag
    questions.value = ques
  } catch (e) {
  } finally {
    isLoading.value = false
  }
}

const createChannel = () => {
  removeChannel('LessonQuestionChannel')
  chanel.value = makeChannel(
    'LessonQuestionChannel',
    async (e: any) => {
      getList()
    },
    () => {
      chanel.value.send({
        action: 'follow',
        data: {
          relativeable_id: props.relativeableId,
          relativeable_type: props.relativeableType
        }
      })
    },
  )
}

watch(() => props.relativeableId, () => {
  getList()
  createChannel()
})

onMounted(() => {
  getList()
  createChannel()
  eventBus.on(EVENTS.QUESTION_CREATED, getList)
})

onUnmounted(() => {
  eventBus.off(EVENTS.QUESTION_CREATED, getList)
})

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Array.from(Array(10).keys()), (item, index) => {
          return (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: index,
            ref_for: true,
            ref: "skeleton",
            type: "list-item-avatar-three-line",
            class: "mx-auto"
          }))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (questions.value.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: question.id,
              onClick: ($event: any) => (onQuestionClick(question)),
              class: "ps-0"
            }, {
              prepend: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(question.answersCount), 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'question-active': question.answersCount > 0, 'question-deactive': question.answersCount == 0 })
                  }, " Ans ", 2 /* CLASS */)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, {
                  textContent: _toDisplayString(question.title)
                }, null, 8 /* PROPS */, ["textContent"]),
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    (question.createdAt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(question.createdAt.substring(0, 10)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-thumb-up", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createTextVNode(" " + _toDisplayString(question.voteValues), 1 /* TEXT */)
                    ]),
                    (question.user && question.user.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: question.user.image.url,
                          style: {"width":"15px"}
                        }, null, 8 /* PROPS */, _hoisted_7))
                      : _createCommentVNode("v-if", true),
                    (question.user && question.user.name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(question.user.name), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
          }), 128 /* KEYED_FRAGMENT */)),
          (pagination.value.totalPages > 1)
            ? (_openBlock(), _createBlock(_component_v_pagination, {
                key: 0,
                modelValue: pagination.value.page,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((pagination.value.page) = $event)),
                  selectPage
                ],
                length: pagination.value.totalPages,
                class: "mt-4 mb-5 pb-5"
              }, null, 8 /* PROPS */, ["modelValue", "length"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!isLoading.value && questions.value.length == 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, "質問はまだありません。"))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})